import * as React from 'react';
import Layout from '../../components/Layout';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import LanguageSwitcher from '../../components/LanguageSwitcher';
import ValuableContentLanding from '../../components/ValuableContentLanding';
import { getVideoSrc } from '../../constants/constants';
import { useTranslation } from 'react-i18next';
import IntroCreatePlaybooksDragAndDrop from '../../components/IntroCreatePlaybooksDragAndDrop';
import PlaybookFeatures from '../../components/PlaybookFeatures';
import InstallApp from '../../components/InstallApp';
import OpinionsFromUsers from '../../components/OpinionsFromUsers';

export default function TenFundamentalSpacingRulesPage() {
    const { t, i18n } = useTranslation();

    const drills = [
        //the cat and the mouse
        {
            id: 1,
            title: t('TenFundamentalSpacingRulesPage02'),
            // description: t('FiveDrillsManychatPage03'),
            image: '/images/spacing/spacing-1.gif',
            // videoUrl: getVideoSrc('drill-1-2on2-ball-screen-def', i18n.language)
        },
        {
            id: 2,
            title: t('TenFundamentalSpacingRulesPage03'),
            // description: t('FiveDrillsManychatPage03'),
            image: '/images/spacing/spacing-2.gif',
            // videoUrl: getVideoSrc('drill-1-2on2-ball-screen-def', i18n.language)
        },
        {
            id: 3,
            title: t('TenFundamentalSpacingRulesPage04'),
            // description: t('FiveDrillsManychatPage03'),
            image: '/images/spacing/spacing-3.gif',
            // videoUrl: getVideoSrc('drill-1-2on2-ball-screen-def', i18n.language)
        },
        {
            id: 4,
            title: t('TenFundamentalSpacingRulesPage05'),
            // description: t('FiveDrillsManychatPage03'),
            image: '/images/spacing/spacing-4.gif',
            // videoUrl: getVideoSrc('drill-1-2on2-ball-screen-def', i18n.language)
        },
        {
            id: 5,
            title: t('TenFundamentalSpacingRulesPage06'),
            // description: t('FiveDrillsManychatPage03'),
            image: '/images/spacing/spacing-5.gif',
            // videoUrl: getVideoSrc('drill-1-2on2-ball-screen-def', i18n.language)
        },
    ];

    return (
        <>
            <Layout>
                <Header />
                <ValuableContentLanding
                    drills={drills}
                    title={t('TenFundamentalSpacingRulesPage00')}
                    buttonText={t('TenFundamentalSpacingRulesPage01')}
                />
                <IntroCreatePlaybooksDragAndDrop />
                <PlaybookFeatures />
                <InstallApp />
                <OpinionsFromUsers />
                <Footer />
                <LanguageSwitcher />
            </Layout>
        </>
    );
}
